import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FF4B55"
  }} d="M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.378V126.62  c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38  C512,406.557,494.833,423.724,473.655,423.724z" /><path style={{
    fill: "#73AF00"
  }} d="M38.345,88.275C17.167,88.275,0,105.442,0,126.62V385.38c0,21.177,17.167,38.345,38.345,38.345  h147.034V88.275H38.345z" /><circle style={{
    fill: "#FFE15A"
  }} cx={185.45} cy={255.999} r={79.38} /><path style={{
    fill: "#FF4B55"
  }} d="M211.932,229.516v35.31c0,14.603-11.88,26.483-26.483,26.483s-26.483-11.88-26.483-26.483v-35.31  H211.932 M220.759,211.861h-70.621c-4.875,0-8.828,3.953-8.828,8.828v44.138c0,24.376,19.762,44.138,44.138,44.138  s44.138-19.762,44.138-44.138v-44.138C229.587,215.814,225.634,211.861,220.759,211.861L220.759,211.861z" /><path style={{
    fill: "#F5F5F5"
  }} d="M211.932,229.516v35.31c0,14.603-11.88,26.483-26.483,26.483s-26.483-11.88-26.483-26.483v-35.31  H211.932" /><g><circle style={{
      fill: "#FFE15A"
    }} cx={150.07} cy={220.689} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={220.69} cy={220.689} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={150.07} cy={255.999} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={220.69} cy={255.999} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={185.38} cy={220.689} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={211.88} cy={288.549} r={4.414} /><circle style={{
      fill: "#FFE15A"
    }} cx={159.4} cy={288.549} r={4.414} /></g><g><path style={{
      fill: "#41479B"
    }} d="M191.149,253.761v7.602c0,3.144-2.558,5.702-5.702,5.702s-5.702-2.558-5.702-5.702v-7.602   L191.149,253.761" /><path style={{
      fill: "#41479B"
    }} d="M191.149,235.74v7.602c0,3.144-2.558,5.702-5.702,5.702s-5.702-2.558-5.702-5.702v-7.602H191.149" /><path style={{
      fill: "#41479B"
    }} d="M191.149,271.969v7.602c0,3.144-2.558,5.702-5.702,5.702s-5.702-2.558-5.702-5.702v-7.602H191.149" /><path style={{
      fill: "#41479B"
    }} d="M206.506,253.761v7.602c0,3.144-2.558,5.702-5.702,5.702s-5.702-2.558-5.702-5.702v-7.602   L206.506,253.761" /><path style={{
      fill: "#41479B"
    }} d="M175.794,253.761v7.602c0,3.144-2.558,5.702-5.702,5.702s-5.702-2.558-5.702-5.702v-7.602   L175.794,253.761" /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };